import React, { useState, useEffect } from 'react';
import i18n from '../lang/i18n';
import LanguageButton from '../shared/layout/components/buttons/LanguageButton';

const LanguageProvider = ({ children }) => {
    const [language, setLanguage] = useState(null);

    useEffect(() => {
        const savedLanguage = localStorage.getItem('selectedLanguage') || localStorage.getItem('language');
        if (savedLanguage) {
            setLanguage(savedLanguage);
            i18n.changeLanguage(savedLanguage);
            return;
        }
        const defaultLanguage = 'en';
        setLanguage(defaultLanguage);
        localStorage.setItem('selectedLanguage', defaultLanguage);
        localStorage.setItem('language', defaultLanguage);
        i18n.changeLanguage(defaultLanguage);
    }, []);

    const handleLanguageSelect = (lang) => {
        setLanguage(lang);
        localStorage.setItem('selectedLanguage', lang);
        localStorage.setItem('language', lang);
    i18n.changeLanguage(lang);
    };

    return <>{children}</>;
};

export default LanguageProvider;
